export const Types = {
  EXPAND_ROW: 'EXPAND_ROW',
  COLLAPSE_ROW: 'COLLAPSE_ROW'
};

export const expandRow = row => ({
  type: Types.EXPAND_ROW,
  row
});

export const collapseRow = () => ({
  type: Types.COLLAPSE_ROW
});



// WEBPACK FOOTER //
// ./public/pages/ListBreaks/actions.js